export default {
    "NotSupportFile": "No soporta este archivo, por favor intenta con otro.",
    "LoginWithGoogle": "Iniciar con Google",
    "SignUpWithGoogle": "Registrarse con Google",
    "BachFileNoLimit": "Procesar los Archivos Grandes Sin Limitación de Tamaño Por Lotes",
    "ConvertVideoTo300Formats": "Convertir Video a 300+ Formatos de Audio con Un Solo Clic",
    "120XDownloadSites": "Descargar Audio de 10,000+ Sitios Web Populares con 120 Veces Más Rápido",
    "DownloadDesktopToExtract": "Descargar la versión de escritorio para extraer el audio de YouTube y de más de 10,000 otros sitios",
    "DownloadDesktopNoLimit": "Descargar la Versión de Escritorio para Procesar los Archivos Grandes Sin Limitación de Tamaño Por Lotes",
    "BachThousandOfFormats": "Convertir por lotes los archivos de video y audio a más de 1,000 formatos a una velocidad 120 veces superior",
    "DownloadVIdeoByThousandsOfSites": "Descargar y guardar videos de 10,000+ sitios web como YouTube, TikTok, Instagram, etc.",
    "RichEditingFeatures": "Amplias funciones de edición de video integradas: unir, cortar, recortar, marca de agua, etc.",
    "ConvertMusicWithDrm": "Convertir Apple Music a MP3 sin DRM (Sólo la versión para Windows)",
    "Try It Free": "Pruébalo Gratis",
    "NotNow": "Ahora No",
    "300Formats": "300+ Formatos",
    "Convert300FormatsByDesktop": "Convertir videos a más de 300 formatos de audio con el convertidor de audio de escritorio",
    "ExtractingAudio": "Extrayendo Audio...",
    "120XFasterToConvert": "Convertir Videos a Audio con 120 Veces Más Rápido en HitPaw Video Converter",
    "FailedToExtract": "Ha fallado la extracción de audio, intenta obtener el audio del video con el potente HitPaw Video Converter.",
    "SureToStopExtract": "¿Estás seguro de que quieres dejar de extraer el audio?",
    "Cancel": "Cancelar",
    "Stop": "Detener",
    "DownloadAudio": "Descargando Audio...",
    "120XDownloadVideoFromWebsites": "Descargar Audio de 10,000+ Sitios Web Populares en HitPaw Video Converter con 120 Veces Más Rápido",
    "SureToStopDownload": "¿Estás seguro de que quieres dejar de descargar audio?",
    "ExtractingAudioInThousandsSites": "Extraer audio de YouTube y otros sitios web usando potente HitPaw Video Converter.",
    "Upload New Video": "Subir Nuevo Video",
    "Download": "Descargando Audio...",
    "Download Successful": "¡Descargar con éxito!",
    "Failed to download": "Ha fallado la descarga.",
}